/**
 * 2021-2024 Stadt Wolfsburg
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import {connect} from 'react-redux';

import PropTypes from 'prop-types';

class WobPageTitle extends React.Component {
    static propTypes = {
        separator: PropTypes.string,
        theme: PropTypes.object
    };
    static defaultProps = {
        separator: " - "
    };
    componentDidMount() {
        this.defaultTitle = document.title;
    }
    componentDidUpdate(prevProps) {
        if (this.props.theme.title && this.props.theme.title !== prevProps.theme.title) {
            document.title = [this.defaultTitle, this.props.theme.title].join(this.props.separator);
        }
    }
    render() {
        return null;
    }
}

const selector = (state) => ({
    theme: state.theme.current || {}
});

export default connect(selector, {
})(WobPageTitle);
